import { jsx as _jsx } from "react/jsx-runtime";
import React, { isValidElement } from "react";
export function useNavigationElement({ mode, label, linkProps, isActive, isExpanded, onClick, onKeyDown }) {
    // if mode is navigation or interactive and label is JSX, then clone the label element with the focus target data attribute applied to it
    if (mode !== "navigation" && mode !== "interactive") {
        return undefined;
    }
    if (linkProps) {
        return (_jsx("a", { ...linkProps, "aria-current": isActive ? true : undefined, "aria-expanded": isExpanded, 
            // narrow down type for linting, <a> without [href] isn't a semantic link
            href: linkProps.href, onClick: onClick, onKeyDown: onKeyDown, "data-primary-focus-target": true, children: label }));
    }
    if (isValidElement(label)) {
        return React.cloneElement(label, {
            // TODO: somehow check that it's actually interactive
            "data-primary-focus-target": true,
            onKeyDown: (event) => {
                label.props.onKeyDown?.(event);
                onKeyDown(event);
            },
            onClick: (event) => {
                label.props.onClick?.(event);
                onClick(event);
            },
            ...(mode === "navigation"
                ? {
                    "aria-current": isActive ? true : undefined,
                    "aria-expanded": isExpanded
                }
                : {})
        });
    }
    return undefined;
}
